import { NavRoute } from "@/models/navRoutes.model";
import { siteRoutes } from "./siteRoutes";
import { Profile } from "@/models/Profile.model";

// Change to a function that returns routes based on user profile
export const getNavRoutes = (user?: Profile): NavRoute[] => {
  // Base routes that everyone gets
  const routes: NavRoute[] = [
    {
      path: siteRoutes.home.path,
      label: siteRoutes.home.label,
    },
    {
      path: siteRoutes.jobs.overview.path,
      label: siteRoutes.jobs.overview.label,
    },
  ];

  // Add admin routes if user is admin
  if (user?.isAdmin) {
    routes.push({
      path: siteRoutes.admin.users.overview.path,
      label: siteRoutes.admin.users.overview.label,
    });
  }

  return routes;
};
